import { fiveZoneTeeth } from '../constants';

const fiveZoneToothSet = new Set<string>(fiveZoneTeeth as string[]);

export function isFiveZoneTooth(toothNumber: string): boolean {
    return fiveZoneToothSet.has(toothNumber);
}
